import React, { useEffect, useState } from "react"
import { Modal, Spin, message } from "antd"
import TableCustom from "src/components/Table/CustomTable"

const DetailModal = ({ open, onCancel, recordId, api, type }) => {
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [totals, setTotals] = useState({})
  const [simData, setSimData] = useState({
    allSims: [],
    soldSims: [],
    remainSims: [],
    stats: { total: 0, da_ban: 0, ton_kho: 0 },
  })

  const columns = [
    {
      title: "STT",
      dataIndex: "ID",
      align: "center",
      render: (text, record, index) => index + 1, 
    },
    {
      title: "Số thuê bao",
      dataIndex: "phone_number",
      align: "center",
    },
    {
      title: "Số seri",
      dataIndex: "serial_number",
      align: "center",
    },
  ]

  const fetchPurchaseDetail = async () => {
    if (!recordId) return
    setLoading(true)
    try {
      const response = await api(recordId)

      const raw = response?.success
      console.log("Raw data:", raw)

      if (raw && !Array.isArray(raw)) {
        // Tất cả sim (gom từ sim_groups.details)
        const allSims =
          raw?.sim_groups?.flatMap(group => group.details || []) || []

        // Sim đã bán (API có sẵn)
        const soldSims = raw?.sims_sold || []

        // Sim còn lại (API có sẵn sims_in_stock, fallback nếu rỗng thì lọc theo sold)
        const remainSims =
          raw?.sims_in_stock?.length > 0
            ? raw.sims_in_stock
            : allSims.filter(sim => sim.sold === 0)

        const stats = raw?.stats || {
          total_sim: allSims.length,
          da_ban: soldSims.length,
          ton_kho: remainSims.length,
        }
        // Hiển thị theo type
        if (type === "all") {
          setDataSource(allSims)
        }
        if (type === "sold") {
          setDataSource(soldSims)
        }
        if (type === "remain") {
          setDataSource(remainSims)
        }
      } else {
        message.error("Không thể lấy dữ liệu.")
      }
    } catch (error) {
      console.error("Lỗi:", error)
      message.error("Đã xảy ra lỗi.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (open) fetchPurchaseDetail()
  }, [open, type])

  return (
    <Modal
      open={open}
      title="Chi tiết SIM tồn kho"
      onCancel={onCancel}
      footer={null}
      width={900}
    >
      <Spin spinning={loading}>
        <TableCustom
          isPrimary
          columns={columns}
          dataSource={dataSource}
          rowKey={record => record.ID}
          pagination={false}
          scroll={{ x: "max-content" }}
        />
      </Spin>
    </Modal>
  )
}

export default DetailModal
